import { useState } from 'react';
import { useGeneratorStore } from '../generatorStore';

const hotThemes = ['魔法森林', '太空冒险', '恐龙世界', '海底探险', '公主城堡'];

export default function ThemeStep() {
  const { params, setParams, setStep } = useGeneratorStore();
  const [theme, setTheme] = useState(params.theme);

  const canNext = theme.trim().length >= 2;

  const handleNext = () => {
    if (!canNext) return;
    setParams({ theme: theme.trim() });
    setStep('config');
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>创作你的绘本故事</h2>
      <p style={subtitleStyle}>输入一个主题，AI 将为你生成一本完整的绘本</p>

      <div style={inputWrapStyle}>
        <label style={labelStyle}>故事主题</label>
        <input
          type="text"
          value={theme}
          onChange={(e) => setTheme(e.target.value)}
          placeholder="例如：一只勇敢的小刺猬寻找星星的故事"
          style={inputStyle}
          maxLength={100}
        />
        <div style={hintStyle}>
          {theme.trim().length < 2 ? '最少输入 2 个中文字符' : `${theme.trim().length} / 100`}
        </div>
      </div>

      <div style={hotWrapStyle}>
        <div style={hotLabelStyle}>热门主题</div>
        <div style={hotGridStyle}>
          {hotThemes.map((t) => (
            <button
              key={t}
              onClick={() => setTheme(t)}
              style={{
                ...hotBtnStyle,
                background: theme === t ? 'rgba(124,77,255,0.3)' : 'rgba(255,255,255,0.06)',
                borderColor: theme === t ? 'rgba(124,77,255,0.5)' : 'rgba(255,255,255,0.1)',
              }}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      <div style={actionsStyle}>
        <button
          onClick={handleNext}
          disabled={!canNext}
          style={{
            ...btnPrimaryStyle,
            opacity: canNext ? 1 : 0.4,
            cursor: canNext ? 'pointer' : 'not-allowed',
          }}
        >
          下一步 →
        </button>
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  maxWidth: '600px',
  margin: '0 auto',
  padding: '40px 20px',
};

const titleStyle: React.CSSProperties = {
  fontSize: '28px',
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: '8px',
  textAlign: 'center',
};

const subtitleStyle: React.CSSProperties = {
  fontSize: '14px',
  color: 'rgba(255,255,255,0.5)',
  marginBottom: '40px',
  textAlign: 'center',
};

const inputWrapStyle: React.CSSProperties = {
  marginBottom: '32px',
};

const labelStyle: React.CSSProperties = {
  display: 'block',
  fontSize: '14px',
  color: 'rgba(255,255,255,0.7)',
  marginBottom: '8px',
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '14px 16px',
  borderRadius: '12px',
  border: '1px solid rgba(255,255,255,0.15)',
  background: 'rgba(255,255,255,0.05)',
  color: '#fff',
  fontSize: '16px',
  outline: 'none',
  boxSizing: 'border-box',
};

const hintStyle: React.CSSProperties = {
  fontSize: '12px',
  color: 'rgba(255,255,255,0.4)',
  marginTop: '6px',
  minHeight: '18px',
};

const hotWrapStyle: React.CSSProperties = {
  marginBottom: '40px',
};

const hotLabelStyle: React.CSSProperties = {
  fontSize: '13px',
  color: 'rgba(255,255,255,0.5)',
  marginBottom: '12px',
};

const hotGridStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
};

const hotBtnStyle: React.CSSProperties = {
  padding: '8px 16px',
  borderRadius: '20px',
  border: '1px solid rgba(255,255,255,0.1)',
  background: 'rgba(255,255,255,0.06)',
  color: 'rgba(255,255,255,0.85)',
  fontSize: '14px',
  cursor: 'pointer',
  transition: 'all 0.2s',
};

const actionsStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
};

const btnPrimaryStyle: React.CSSProperties = {
  padding: '12px 32px',
  borderRadius: '10px',
  border: 'none',
  background: 'linear-gradient(135deg, #7c4dff 0%, #448aff 100%)',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
};
